import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Theme } from '../../../../../../../../../shared/styles/theme/theme.ts';
import { useTranslation } from 'react-i18next';
import { IThirdStepData } from '../content.popup.tsx';

export const ThirdStep: FC<IThirdStep> = ({ thirdStepData: { reimportResult } }) => {
  const { t } = useTranslation();
  const { recordsUpdated, recordsInserted } = reimportResult;
  const createdText =
    typeof recordsInserted === 'number'
      ? t('settings.article_import_created', { count: recordsInserted })
      : '';
  const updatedText =
    typeof recordsUpdated === 'number'
      ? t('settings.article_import_updated', { count: recordsUpdated })
      : '';
  const summary = [createdText, updatedText].filter(Boolean).join(', ');
  return (
    <Stack
      sx={{
        alignItems: 'center',
        height: 'calc(100vh - 177px)',
        justifyContent: 'center',
        overflowY: 'scroll',
      }}
    >
      <Stack
        sx={{
          backgroundColor: Theme.palette.primary.main,
          borderRadius: '50%',
          width: 63,
          height: 63,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CheckIcon sx={{ fill: Theme.palette.background.default, fontSize: 55, fontWeight: 600 }} />
      </Stack>
      <Typography sx={{ fontWeight: 600, fontSize: 24, mb: 1, mt: 2 }}>
        {t('common.finished')}
      </Typography>
      <Typography
        sx={{
          fontSize: 16,
          color: Theme.palette.text.secondary,
          fontWeight: 500,
          mb: 1,
          mt: '10px',
        }}
      >
        {t('settings.article_import_title')}
      </Typography>
      <Typography
        sx={{
          fontSize: 16,
          color: Theme.palette.text.secondary,
          fontWeight: 500,
          mb: 1,
          mt: '10px',
          textDecoration: 'underline',
        }}
      >
        {summary ? `${summary}.` : ''}
      </Typography>
    </Stack>
  );
};

interface IThirdStep {
  thirdStepData: IThirdStepData;
}
